import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const Owner = forwardRef<SVGSVGElement, Props>(
	({ className, ...props }, ref) => {
		return (
			<svg
				ref={ref}
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="currentColor"
				role="img"
				focusable="false"
				aria-hidden="true"
				xmlns="http://www.w3.org/2000/svg"
				className={className}
				{...props}
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M2.49413 12.7549C2.68397 12.3872 3.1353 12.2421 3.50292 12.4316C3.87032 12.6217 4.01388 13.0746 3.82421 13.4424C3.72958 13.6259 3.65773 13.8092 3.60253 13.9834C3.56262 14.1094 3.51979 14.2626 3.47557 14.4355C3.37306 14.8366 2.96431 15.0789 2.56346 14.9766C2.16295 14.8738 1.92122 14.4653 2.02343 14.0645C2.07188 13.8749 2.12266 13.6928 2.17382 13.5312C2.25155 13.2859 2.35596 13.0227 2.49413 12.7549Z"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.498 12.4316C12.8656 12.2423 13.3171 12.3873 13.5068 12.7549C13.645 13.0227 13.7494 13.286 13.8271 13.5312C13.8783 13.6928 13.9281 13.875 13.9766 14.0645C14.0789 14.4654 13.8372 14.8739 13.4365 14.9766C13.0357 15.0789 12.6279 14.8366 12.5254 14.4355C12.4811 14.2625 12.4374 14.1094 12.3974 13.9834C12.3422 13.8092 12.2695 13.6259 12.1748 13.4424C11.9853 13.0746 12.1306 12.6216 12.498 12.4316Z"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M3.9785 9.30664C4.22333 8.97309 4.69182 8.90089 5.02538 9.14551C5.35879 9.39058 5.4313 9.85964 5.18651 10.1934C5.06436 10.3599 4.96453 10.5299 4.8828 10.6934C4.82376 10.8115 4.75712 10.9563 4.68651 11.1201C4.52261 11.4999 4.08194 11.6752 3.70214 11.5117C3.32226 11.3478 3.1469 10.9065 3.31054 10.5264C3.38791 10.3468 3.46629 10.1749 3.54198 10.0234C3.65695 9.79344 3.80044 9.5494 3.9785 9.30664Z"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M10.7998 9.14551C11.1334 8.90092 11.6019 8.97309 11.8467 9.30664C12.0247 9.5494 12.1682 9.79344 12.2832 10.0234C12.3589 10.1749 12.4373 10.3468 12.5146 10.5264C12.6783 10.9065 12.5029 11.3478 12.123 11.5117C11.7432 11.6752 11.3026 11.5 11.1387 11.1201C11.068 10.9563 11.0014 10.8115 10.9424 10.6934C10.8606 10.5299 10.7608 10.3599 10.6387 10.1934C10.3938 9.85963 10.4664 9.39058 10.7998 9.14551Z"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M7.99608 8C8.27394 8.00002 8.53978 8.01382 8.79296 8.04102C9.20418 8.08549 9.50215 8.45565 9.458 8.86719C9.41367 9.27855 9.04396 9.57705 8.6328 9.5332C8.43553 9.51201 8.22324 9.50002 7.99608 9.5C7.77194 9.5 7.56213 9.51185 7.36815 9.53418C6.95739 9.58109 6.5865 9.28597 6.53905 8.875C6.49188 8.46374 6.78717 8.09228 7.19823 8.04492C7.45147 8.01579 7.71754 8 7.99608 8Z"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M7.99999 1C9.51855 1.00026 10.75 2.23138 10.75 3.75C10.75 5.26862 9.51855 6.49974 7.99999 6.5C6.48142 6.49974 5.24999 5.26862 5.24999 3.75C5.24999 2.23138 6.48142 1.00026 7.99999 1Z"
				></path>
			</svg>
		)
	},
)
